import './EpisodeDetailInfo.scss'

import React from 'react'
import { some, isNull } from 'lodash'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import 'dayjs/locale/zh-tw'

import { Maybe } from '../../types/generated'

const localeCode: { [key: string]: string } = {
  'zh-Hant': 'zh-tw',
  'zh-Hans': 'zh-cn',
  en: 'en',
}

interface Props {
  episodeTotal?: Maybe<number>
  releaseStart?: Maybe<string | Date>
  score?: Maybe<number>
}

export default function EpisodeDetailInfo({ episodeTotal, releaseStart, score }: Props) {
  const { t, i18n } = useTranslation()

  return !some([episodeTotal, releaseStart, score]) ? null : (
    <div className="EpisodeDetailInfo">
      {!!episodeTotal && (
        <>
          <span>
            {t('program.totalEpisodes')} {episodeTotal}
          </span>
          {(releaseStart || score) && <span className="EpisodeDetailInfo__divider" />}
        </>
      )}
      {releaseStart && (
        <>
          <span className="EpisodeDetailInfo__text">{t('program.released')}</span>
          <span>{dayjs(releaseStart).locale(localeCode[i18n.language]).format('MMM D YYYY')}</span>
          {!isNull(score) && <span className="EpisodeDetailInfo__divider" />}
        </>
      )}
      {!isNull(score) && (
        <>
          <span className="EpisodeDetailInfo__text">{t('program.score')}</span>
          <span>{score}</span>
        </>
      )}
    </div>
  )
}
